import React from "react";
const Url = process.env.REACT_APP_SERVER_URL;

const VideoModal = ({ videoUrl, setShowVideoModal }) => {
  console.log(`${Url}/videoUrl`);
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex justify-content-center align-items-center"
      style={{ zIndex: 1050 }}
    >
      <div
        className="position-relative bg-white rounded p-3"
        style={{ maxWidth: "800px", width: "90%" }}
      >
        <button
          onClick={() => setShowVideoModal(false)}
          className="btn btn-sm position-absolute top-0 end-0 m-2"
        >
          ✖
        </button>
        <div className="ratio ratio-16x9">
          <iframe
            width="100%"
            height="100%"
            src={`${Url}/${videoUrl}`}
            title="Car Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
